import { render, staticRenderFns } from "./LockTemplate.vue?vue&type=template&id=20783fc7&scoped=true"
import script from "./LockTemplate.vue?vue&type=script&lang=js"
export * from "./LockTemplate.vue?vue&type=script&lang=js"
import style0 from "./LockTemplate.vue?vue&type=style&index=0&id=20783fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20783fc7",
  null
  
)

export default component.exports